module.exports = __webpack_public_path__ + "media/images/worksapp-29367dc5.jpg";